import React, { useRef, useState, useEffect } from 'react';
import wbs_sign from '../../assets/images/AwardsCarousel/wbsAwardSign.png';
import wbs_logo from '../../assets/images/AwardsCarousel/wbsLogo.png';
import unltd_sign from '../../assets/images/AwardsCarousel/UnltdAwardSign.png';
import unltd_logo from '../../assets/images/AwardsCarousel/UnltdLogo.png';
import sage_sign from '../../assets/images/AwardsCarousel/SageAwardSign.png';
import sage_logo from '../../assets/images/AwardsCarousel/SageLogo.png';
import yotewo_sign from '../../assets/images/AwardsCarousel/yotewo.png';
import yotewo_logo from '../../assets/images/AwardsCarousel/yotewoLogo.png';

const AwardCarousel = () => {
  const containerRef = useRef(null);
  const [trackWidth, setTrackWidth] = useState(0);
  const signImageClass = 'w-40 h-40';
  const logoImageClass = 'w-40 h-24';

  const images = [
    [
      { src: wbs_sign, className: signImageClass },
      { src: wbs_logo, className: logoImageClass },
    ],
    [
      { src: unltd_sign, className: signImageClass },
      { src: unltd_logo, className: logoImageClass },
    ],
    [
      { src: sage_sign, className: signImageClass },
      { src: sage_logo, className: logoImageClass },
    ],
    [
      { src: yotewo_sign, className: signImageClass },
      { src: yotewo_logo, className: logoImageClass },
    ],
  ];

  const carouselImages = [...images, ...images,...images,...images,];

  useEffect(() => {
    if (containerRef.current) {
      const children = containerRef.current.children;
      let width = 0;
      // Only count first set of items
      for (let i = 0; i < children.length / 2; i++) {
        width += children[i].offsetWidth;
      }
      setTrackWidth(width);
    }
  }, [images]);

  return (
    <div className="overflow-hidden w-full h-auto relative group">
      <div className="bg-white text-black py-10">
        <h2 className="text-4xl font-bold mb-7 text-center">
        Award Winning Innovation
        </h2>
        <div
          ref={containerRef}
          className="flex whitespace-nowrap animate-scroll group-hover:pause-scroll gap-20"
          style={{
            '--track-width': `${trackWidth}px`,
          }}
        >
          {carouselImages.map((item, i) => (
            <div key={i} className="flex-none item-center">
              {Array.isArray(item) ? (
                <div className="flex flex-col items-center space-y-2">
                  {item.map((img, idx) => (
                    <img
                      key={idx}
                      src={img.src}
                      alt={`carousel-${i}-${idx}`}
                      className={`${img.className} object-contain rounded-xl`}
                    />
                  ))}
                </div>
              ) : (
                <img
                  src={item.src}
                  alt={`carousel-${i}`}
                  className={`${item.className} object-contain rounded-xl`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AwardCarousel;
